var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-logo"},[(_vm.logo)?_c('v-img',{attrs:{"src":_vm.mediaHost + _vm.logo,"height":"100%","contain":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }